module.exports = __webpack_public_path__ + "img/black-li-icon4.f7e01ae7.png";